$(function () {
    var openSubMenu = function ($this) {
        let $siteMenu = $this.closest('.site-menu');
        let index = $this.index();
        let $subMenu = $siteMenu.find('.site-submenu-wr .mode-list .mode-item');
        let $listMenu = $this.closest('.site-menu-wr');

        $this.addClass('active');
        $this.siblings('.site-menu-item').removeClass('active');

        if ($subMenu.eq(index).length > 0 && !$subMenu.eq(index).hasClass('open')) {
            $subMenu.removeClass('open');
            $subMenu.eq(index).addClass('open');
            $('body').addClass('fixed-body');
            if ($(window).width() < '1023') {
                $listMenu.addClass('open-submenu');
            }

            if ($(window).width() > '1023') {
                $('.overflow-body').addClass('show-overflow');
            }
        } else {
            if ($(window).width() > 1023) {
                $('.overflow-body').removeClass('show-overflow');
            }

            $subMenu.removeClass('open');
            $('body').removeClass('fixed-body');
        }

        $('.product-page .product-row .product-photo-wr .flair').addClass('hidden-block');
    };

    var closeSubMenu = function ()
    {

        let $parent = $('.site-menu');
        let $mobileIcon = $('.mobile-menu-icon');

        $parent.removeClass('open');
        $parent.find('.site-submenu-wr .mode-list .mode-item').removeClass('open');
        $parent.find('.site-menu-item').removeClass('active');
        $parent.children('.site-menu-wr').removeClass('open-submenu');
        $mobileIcon.removeClass('active');
        $('body').removeClass('fixed-body');
        $('.overflow-body').removeClass('show-overflow');
        $parent.removeClass('desktop-menu-opened');
        $parent.removeClass('show-all-categories');
        $('.product-page .product-row .product-photo-wr .flair').removeClass('hidden-block');
        
        const $catalogNavHeader = $('.catalog-nav-header');
        const $catalogList = $('.site-catalog-categories-list');
        const $subcategoryLists = $('.site-catalog-subcategories-list');
        // Только список в шапке, чтобы не задевать другие .site-menu-list на странице
        const $siteMenuList = $('.site-menu .site-menu-list');
        const $fixedHeaderBlock = $('.fixed-header-block');
        
        $catalogNavHeader.hide();
        $catalogList.hide();
        $subcategoryLists.hide();
        $siteMenuList.show();
        $fixedHeaderBlock.show();
        catalogLevel = 0;
    };

    $('body .overflow-body').hover(
        function()
        {
        }
    )

    $('.site-menu').on('click', '.all-catalog-item .all-catalog-link', function (event) {
        if ($(window).width() <= 1023) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        const $item = $(this).closest('.all-catalog-item');
        const $siteMenu = $item.closest('.site-menu');
        const isOpen = $siteMenu.hasClass('show-all-categories');

        if (isOpen) {
            $siteMenu.removeClass('show-all-categories');
            $item.removeClass('active');
            $('.overflow-body').removeClass('show-overflow');
            return;
        }

        $item.addClass('active');
        $item.siblings('.site-menu-item').removeClass('active');
        $siteMenu.addClass('show-all-categories');
        $('.overflow-body').addClass('show-overflow');
    });

    $('header .mobile-menu-icon').on('click', function () {
        let $siteMenu = $('.site-menu');
        let $listMenu = $siteMenu.find('.site-menu-wr');
        let $modeItem = $siteMenu.find('.site-submenu-wr .mode-list .mode-item');

        if ($(this).hasClass('active')) {
            $siteMenu.removeClass('open');
            $(this).removeClass('active');
            $('.product-size-block').removeClass('open');
            closeSubMenu();
            $('header').removeClass('mob-menu-open');
        } else {
            $(this).addClass('active');
            $siteMenu.addClass('open');
            $('body').addClass('fixed-body');
            $('.overflow-body').addClass('show-overflow');
            $('header').addClass('mob-menu-open');
        }
    });

    $('.site-menu .back-menu-link').on('click', function () {
        let $parent = $(this).closest('.site-menu');

        $parent.find('.mode-list .mode-item').removeClass('open');
        $parent.find('.site-menu-wr').removeClass('open-submenu');
        $parent.find('.site-menu-item').removeClass('active');
    });

    $('.overflow-body').on('click', function () {
        closeSubMenu();
        $(this).removeClass('show-open-popup');
        $('.site-popup').removeClass('opened');
    });

    $('.site-menu').on('click', '.all-categories-more-btn', function (event) {
        event.preventDefault();
        const $column = $(this).closest('.all-categories-column');
        const isExpanded = $column.hasClass('expanded');

        $column.toggleClass('expanded', !isExpanded);
        $(this).text(isExpanded ? 'Ещё' : 'Свернуть');
    });

    $('.site-menu .close-button').on('click', function () {
        closeSubMenu();
    });

    $('.site-menu').mouseleave(function (e) {
        if ($('.site-menu').hasClass('desktop-menu-opened') && !$('.site-submenu-wr .mode-list .mode-item').hasClass('open')) {
            closeSubMenu();
        }
    });

    $('header').on('click', function () {
        if ($(window).width() > '1023') {
            closeSubMenu();
        }
    });

    $(document).on('keydown', function (event) {
        if (event.which == 27) {
            closeSubMenu();
        }
    });

    $('.site-popup .close-button').on('click', function (e) {
        closeSubMenu();
    });
    
    if($('.index-page')[0]) {
        $('.double-header').addClass('index-page-double-header')
    }

    if($('#basket-page')[0] || $('#order-page')[0]) {
        $('header').addClass('fixed-page')
    }

    let catalogLevel = 0;

    $('#allCatalogToggleBtn').on('click', function () {
        if ($(window).width() < 1024) {
            const $siteMenuWr = $(this).closest('.site-menu-wr');
            const $siteMenuList = $siteMenuWr.find('.site-menu-list');
            const $catalogList = $siteMenuWr.find('.site-catalog-categories-list');
            const $catalogNavHeader = $('.catalog-nav-header'); // Теперь в header
            const $catalogNavTitle = $('#catalogNavTitle');
            const $fixedHeaderBlock = $('.fixed-header-block');
            
            $siteMenuList.hide();
            $catalogList.show();
            $catalogNavHeader.show();
            $catalogNavTitle.text('Весь каталог');
            $fixedHeaderBlock.hide();
            
            catalogLevel = 1;
        }
    });

    $('.catalog-category-btn').on('click', function () {
        const categoryIndex = $(this).data('category-index');
        const categoryName = $(this).data('category-name');
        const href = $(this).data('href');
        const $siteMenuWr = $(this).closest('.site-menu-wr');
        const $catalogList = $siteMenuWr.find('.site-catalog-categories-list');
        const $subcategoryList = $siteMenuWr.find('.site-catalog-subcategories-list[data-category-index="' + categoryIndex + '"]');
        const $catalogNavTitle = $('#catalogNavTitle');
        
        if ($subcategoryList.length > 0) {
            $catalogList.hide();
            $subcategoryList.show();
            $catalogNavTitle.text(categoryName);
            catalogLevel = 2;
        } else if (href) {
            window.location.href = href;
        }
    });

    $('#catalogNavBack').on('click', function () {
        const $siteMenu = $('.site-menu');
        const $siteMenuWr = $siteMenu.find('.site-menu-wr');
        const $siteMenuList = $siteMenuWr.find('.site-menu-list');
        const $catalogList = $siteMenuWr.find('.site-catalog-categories-list');
        const $subcategoryLists = $siteMenuWr.find('.site-catalog-subcategories-list');
        const $catalogNavHeader = $('.catalog-nav-header');
        const $catalogNavTitle = $('#catalogNavTitle');
        const $fixedHeaderBlock = $('.fixed-header-block');
        
        if (catalogLevel === 2) {
            $subcategoryLists.hide();
            $catalogList.show();
            $catalogNavTitle.text('Весь каталог');
            catalogLevel = 1;
        } else if (catalogLevel === 1) {
            $catalogList.hide();
            $catalogNavHeader.hide();
            $siteMenuList.show();
            $fixedHeaderBlock.show();
            catalogLevel = 0;
        }
    });

    $('#catalogNavClose').on('click', function () {
        const $siteMenu = $('.site-menu');
        const $siteMenuWr = $siteMenu.find('.site-menu-wr');
        const $siteMenuList = $siteMenuWr.find('.site-menu-list');
        const $catalogList = $siteMenuWr.find('.site-catalog-categories-list');
        const $subcategoryLists = $siteMenuWr.find('.site-catalog-subcategories-list');
        const $catalogNavHeader = $('.catalog-nav-header');
        const $catalogNavTitle = $('#catalogNavTitle');
        const $fixedHeaderBlock = $('.fixed-header-block');
        
        $catalogList.hide();
        $subcategoryLists.hide();
        $catalogNavHeader.hide();
        $catalogNavTitle.text('Весь каталог');
        $siteMenuList.show();
        $fixedHeaderBlock.show();
        catalogLevel = 0;
        
        closeSubMenu();
    });
})